<!-- 项目列表 -->

<template>
  <div class="all">
    <div class="" v-loading="loading">
      <!-- 顶部搜索 -->
      <div class="s_wrapper">
        <el-cascader collapse-tags v-model="categoryValue" :options="optionArry" placeholder="项目分类" :props="{ expandTrigger: 'hover', label: 'categoryName', value: 'categoryId', children: 'children', emitPath: false, checkStrictly: false, multiple: true }" @change="onSearch" clearable></el-cascader>
        <el-select class="s_input" v-model="shelfValue" placeholder="选择上下架状态" @change="handleSelect" clearable>
          <el-option v-for="item in shelfOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input class="s_input" v-model="projectName" placeholder="请搜索项目名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-button type="primary" @click="batchChangeStatus('down')">批量下架</el-button>
        <el-button type="primary" @click="batchChangeStatus('up')">批量上架</el-button>
        <el-button type="primary" @click="addProject('up')">申请新项目</el-button>
      </div>

      <!-- 表格 -->
      <div class="g_table" style="max-height: 540; overflow: auto">
        <el-table :data="tableData" style="width: 100%" max-height="540" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" fixed="left"></el-table-column>
          <el-table-column label="序号" width="50" show-overflow-tooltip fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image class="busilicense" :src="scope.row.picList && scope.row.picList.length > 0 ? scope.row.picList[0] : ''" fit="cover" @mouseover="previewImage(scope.row.picList)"></el-image>
            </template>
          </el-table-column> -->
          <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip min-width="200"></el-table-column>
          <el-table-column prop="categoryName" label="分类" show-overflow-tooltip min-width="140"></el-table-column>
          <el-table-column prop="price" label="定价(元)" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="linePrice" label="划线价(元)" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="durationMinute" label="服务时长(min)" show-overflow-tooltip min-width="120"></el-table-column>
          <el-table-column prop="projectCount" label="次数" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="commissionRate" label="员工提成比例(%)" show-overflow-tooltip min-width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.commissionRate ? scope.row.commissionRate : "——" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="commissionAmount" label="员工提成金额(元)" show-overflow-tooltip min-width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.commissionAmount ? scope.row.commissionAmount : "——" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.switch" active-color="#" inactive-color="#E2E2E2" @change="changeStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="210" fixed="right">
            <template slot-scope="scope">
              <el-button size="small" class="btn" type="primary" plain @click="handleModify(scope.row)">修改</el-button>
              <el-button size="small" class="btn" type="danger" plain @click="handleDele(scope.row)">删除</el-button>
              <!-- <el-button class="btn" type="primary" plain @click="handleOpenPicDialog(scope.row)">编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      shelfValue: "", // 是否上架
      shelfOptions: [
        {
          value: "1",
          label: "上架",
        },
        {
          value: "0",
          label: "下架",
        },
      ],
      categoryValue: "", // 请搜索商品类目
      factoryValue: "", // 请搜索厂家
      projectName: "", // 请搜索商品名称
      supplyValue: "", // 请搜索供应商名称
      barCode: "", // 条形码
      optionArry: [],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 选中数据

      // 图片预览
      showViewer: false,
      imgList: [],
      // 编辑图片
      picDialogVisible: false,
      picRuleForm: {
        productName: "",
        totalPic: "",
        picUrl1: "",
        picUrl2: "",
        picUrl3: "",
      },
      picRules: {
        totalPic: [
          {
            validator: () => {
              if (!this.picRuleForm.picUrl1 && !this.picRuleForm.picUrl2 && !this.picRuleForm.picUrl3) {
                return Promise.reject("请至少上传一张图片")
              } else {
                return Promise.resolve()
              }
            },
            trigger: "submit",
          },
        ],
      },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    // 缓存页面的搜索条件
    // let obj = JSON.parse(localStorage.getItem("productList"))
    // this.shelfValue = obj?.shelfValue
    // this.projectName = obj?.projectName
    // this.categoryValue = obj?.categoryValue
    // this.factoryValue = obj?.factoryValue
    // this.currentPage = obj?.currentPage
    // this.barCode = obj?.barCode
    // this.$saveOrUpdateCache("productList", {})
    this.getShopProductList()
    this.getCategoryInfoList()
  },
  methods: {
    addProject() {
      this.$router.push({
        path: "/formalProject/detail/addProduct",
      })
    },
    // 获取项目列表
    getShopProductList() {
      this.loading = true
      this.$axios
        .post(this.$api.selectProjectInfoList, {
          saleStatus: this.shelfValue || null, // 上下架状态
          categoryIdList: this.categoryValue || [], // 请搜索分类
          projectName: this.projectName || null, // 搜索项目名称
          page: this.currentPage,
          pageSize: this.pageSize,
          projectType: 1,
        })
        .then(res => {
          if (res.code == 100) {
            let list = res.result.list.map(e => {
              return {
                ...e,
                switch: e.saleStatus == 1 ? true : false,
              }
            })
            this.tableData = list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 分类
    getCategoryInfoList() {
      this.$axios
        .get(this.$api.projectList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.optionArry = res.result.list
            this.optionArry.map(item => {
              if (item.children.length == 0) {
                item.children = null
              }
            })
          }
          // this.loading = false
        })
    },
    handleOpenPicDialog(row) {
      this.picDialogVisible = true
      this.$set(this.picRuleForm, "productName", row.productName)
      this.$set(this.picRuleForm, "productId", row.productId)
      if (row.picList && Array.isArray(row.picList)) {
        this.$set(this.picRuleForm, "picUrl1", row.picList[0] || "")
        this.$set(this.picRuleForm, "picUrl2", row.picList[1] || "")
        this.$set(this.picRuleForm, "picUrl3", row.picList[2] || "")
      } else {
        this.$set(this.picRuleForm, "picUrl1", "")
        this.$set(this.picRuleForm, "picUrl2", "")
        this.$set(this.picRuleForm, "picUrl3", "")
      }
    },
    // 关闭对话框
    onCancelPicDialog() {
      this.picDialogVisible = false
      this.resetFormPic()
    },
    // 提交表单
    submitFormPic(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post(this.$api.updateShopProductPic, {
              productId: this.picRuleForm.productId,
              shopId: this.$store.state.userInfo.shopId,
              picList: [this.picRuleForm.picUrl1 || "", this.picRuleForm.picUrl2 || "", this.picRuleForm.picUrl3 || ""],
            })
            .then(res => {
              if (res.data.code == 100) {
                this.$message.success(res.data.desc)
                this.getShopProductList()
                this.onCancelPicDialog()
              }
            })
            .catch(err => {
              this.$message.error(err.data.desc)
            })
        }
      })
    },
    // 重置校验
    resetFormPic() {
      this.$refs.picRuleForm.resetFields()
      this.picRuleForm = {}
    },
    handleRemoveLogo1() {
      this.picRuleForm.picUrl1 = ""
    },
    handleSuccess1(res) {
      if (res.code == 100) {
        this.picRuleForm.picUrl1 = res.result.fileUrl
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        })
      }
    },
    handleRemoveLogo2() {
      this.picRuleForm.picUrl2 = ""
    },
    handleSuccess2(res) {
      if (res.code == 100) {
        this.picRuleForm.picUrl2 = res.result.fileUrl
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        })
      }
    },
    handleRemoveLogo3() {
      this.picRuleForm.picUrl3 = ""
    },
    handleSuccess3(res) {
      if (res.code == 100) {
        this.picRuleForm.picUrl3 = res.result.fileUrl
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        })
      }
    },
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },

    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 批量切换上下架状态
    batchChangeStatus(saleStatus) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请先选择项目")
        return
      }
      const action = saleStatus === "up" ? "上架" : "下架"
      const ids = this.multipleSelection.map(item => item.projectId)

      this.$confirm(`确定批量${action}这些项目吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.saleStatusProjectInfo, {
              projectIdList: ids,
              saleStatus: saleStatus === "up" ? 1 : 0,
            })
            .then(res => {
              // 批量操作成功后更新项目列表状态
              this.multipleSelection.forEach(item => {
                item.switch = saleStatus === "up" ? true : false
              })
              this.$message.success(res.desc)
              this.getShopProductList()
            })
            .catch(err => {
              this.$message.error(err.desc)
              this.getShopProductList()
            })
        })
        .catch(() => {
          // 取消操作时恢复之前的选择状态
          this.multipleSelection.forEach(item => {
            item.switch = !item.switch
          })
          this.getShopProductList()
        })
    },
    // 切换上下架
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`确定${row.switch ? "上架" : "下架"}该项目吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.saleStatusProjectInfo, {
              projectIdList: [row.projectId],
              saleStatus: row.switch ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success(res.desc)
              this.getShopProductList()
            })
            .catch(err => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error(err.desc)
              this.getShopProductList()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.getShopProductList()
        })
    },
    // 删除
    handleDele(row) {
      this.$confirm("确定删除该项目？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          return this.$axios.get(this.$api.deletedProjectInfo, {
            params: {
              projectId: row.projectId,
            },
          })
        })
        .then(res => {
          if (res.code == 100) {
            this.$message.success("删除成功")
            this.getShopProductList()
          } else {
            this.$message.error("删除失败")
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 修改跳转
    handleModify(row) {
      localStorage.setItem("productList", JSON.stringify(row))
      this.$router.push({
        path: "/formalProject/detail/modify",
        query: { projectId: row.projectId },
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 下拉选择
    handleSelect(value) {
      this.clearData()
      this.shelfValue = value
      this.getShopProductList()
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getShopProductList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getShopProductList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getShopProductList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList = url
      this.showViewer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.all {
  // 顶部搜索
  .search {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;

    .el-input {
      width: 250px;
      margin-left: 20px;
      margin-bottom: 20px;
    }

    .el-select,
    .el-cascader,
    .el-button {
      margin-left: 20px;
      margin-bottom: 20px;
    }

    ::v-deep .el-cascader {
      width: 250px;

      .el-input,
      .el-input__inner {
        width: 250px;
      }
    }
  }

  .show_img {
    color: #069bbc;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .busilicense {
    display: block;
    width: 80px;
    height: 58px;
    border-radius: 4px;
  }

  // 图片
  .logo_pic {
    position: relative;

    ::v-deep .el-form-item__content {
      width: 100px;
      height: 100px;
    }

    .pic-row {
      display: flex;

      .pic {
        margin-right: 15px;

        .logo_uploader {
          ::v-deep .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          ::v-deep .el-upload:hover {
            border-color: #069bbc;
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #069bbc;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
          }

          .logoimg {
            width: 100px;
            height: 100px;
            display: block;
            object-fit: cover;
          }
        }
      }
    }

    .delpic {
      position: absolute;
      top: -12px;
      color: red;
      font-size: 20px;
      cursor: pointer;
    }

    .delpic1 {
      right: -15px;
    }

    .delpic2 {
      right: -134px;
    }

    .delpic3 {
      right: -250px;
    }
  }
}
</style>
